export const getSharableTestText = (link: string) => {
    return `Olá!\nEste instrumento faz parte do acompanhamento psicológico em andamento.\nAs perguntas ajudam a reunir informações importantes para a avaliação.\nAs respostas são confidenciais e utilizadas apenas para fins profissionais.\nAcesse o instrumento pelo link abaixo:\n${link}`;
};
